import React from "react";
import "flag-icons/css/flag-icons.min.css";

/**
 * Ekte SVG-basert flagg via flag-icons CSS-sprites.
 * Render's konsistent på alle OS (Windows, Mac, Linux, mobil).
 *
 * Props:
 *   iso: ISO 3166-1 alpha-2 (NO/SE/DK/GB/US/...). Påkrevd.
 *   size: "xs" | "sm" | "md" | "lg" – konvenient tailwind-størrelse
 *   title: tooltip (default: iso)
 *   rounded: bool – legg til border-radius
 *   className: ekstra klasser
 */
export default function CountryFlag({ iso, size = "sm", title, rounded = true, className = "", "data-testid": testId }) {
  if (!iso || typeof iso !== "string" || iso.length !== 2) {
    // Fallback: liten globe-glyph
    return (
      <span className={`inline-block ${className}`} title={title || ""} data-testid={testId} aria-hidden="true">🌐</span>
    );
  }
  const code = iso.toLowerCase();
  // flag-icons CSS bruker `fi fi-{cc}` for hver flagg-sprite
  // gb (Great Britain) er korrekt iso-2 for UK
  const dim = {
    xs: "w-3 h-[0.5625rem]",     // 12×9
    sm: "w-4 h-3",               // 16×12
    md: "w-5 h-[0.9375rem]",     // 20×15
    lg: "w-6 h-[1.125rem]",      // 24×18
  }[size] || "w-4 h-3";
  return (
    <span
      className={`fi fi-${code} inline-block ${dim} ${rounded ? "rounded-[2px]" : ""} shrink-0 align-middle ${className}`}
      title={title || iso.toUpperCase()}
      data-testid={testId}
      aria-label={iso.toUpperCase()}
    />
  );
}
